import heNotification from './notification-tracks/he_notification.mp3';
import enNotification from './notification-tracks/en_notification.mp3';

class Sound {
    constructor(source, volume, loop = false) {
        this.sound = new Audio(source);
        this.sound.volume = volume / 100;
        this.sound.loop = loop;
    }

    setSource(language) {
        switch(language) {
            case 'en': 
                this.sound.src = enNotification;
                break;
            case 'he':
            default:
                this.sound.src = heNotification;
                break;
        }
    }

    play() {
        this.sound.play();
    }

    pause() {
        this.sound.pause();
    }
}

let notification = new Sound(heNotification, 100);

export const playNotificationSound = () => {
    notification.setSource(localStorage.getItem('language'));
    notification.play();
};

export const pauseNotificationSound = () => {
    notification.pause();
};
